module.exports = __webpack_public_path__ + "img/the-verge.95305c1a.png";